/* KIS collectie/zoekpagina (agent C): sortering, kolomschakelaar en filterlade bovenop Dawn's facets.js en
   menu-drawer (global.js). Geen eigen fetch: de sortering zet het verborgen sort_by-veld van het filterformulier
   en laat facets.js de sectie opnieuw renderen (filters blijven zo bewaard). */
(function () {
  if (window.KIS_COLLECTION_INIT) return;
  window.KIS_COLLECTION_INIT = true;

  var MOBILE = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  /* ---------- sortering ---------- */
  function syncHiddenSorts(value) {
    document.querySelectorAll('#SortBy, #SortBy-mobile').forEach(function (sel) {
      sel.value = value;
    });
  }

  function paramsForSort() {
    var form = document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile');
    if (!form) return null;
    return new URLSearchParams(new FormData(form)).toString();
  }

  function onSortChange(e) {
    var select = e.target;
    var wrap = select.closest('.kis-toolbar__sort');
    var label = wrap && wrap.querySelector('[data-kis-sort-label]');
    if (label) label.textContent = select.options[select.selectedIndex].text;
    syncHiddenSorts(select.value);
    var params = paramsForSort();
    if (params === null) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
      return;
    }
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(params, null, true);
    } else {
      window.location.search = params;
    }
  }

  function syncSortFromUrl() {
    var value = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('[data-kis-sort]').forEach(function (select) {
      if (value && select.value !== value) {
        var has = Array.prototype.some.call(select.options, function (o) { return o.value === value; });
        if (has) select.value = value;
      }
      var wrap = select.closest('.kis-toolbar__sort');
      var label = wrap && wrap.querySelector('[data-kis-sort-label]');
      if (label) label.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
    });
  }

  /* ---------- kolomschakelaar ---------- */
  function storageKey() {
    return isMobile() ? 'kis:cols:mobile' : 'kis:cols:desktop';
  }

  function readCols() {
    try { return window.localStorage.getItem(storageKey()); } catch (err) { return null; }
  }

  function writeCols(value) {
    try { window.localStorage.setItem(storageKey(), value); } catch (err) {}
  }

  function applyCols(value) {
    var grid = document.getElementById('product-grid');
    if (grid && grid.classList.contains('kis-grid')) {
      if (isMobile()) grid.setAttribute('data-cols-mobile', value);
      else grid.setAttribute('data-cols', value);
    }
    document.querySelectorAll('[data-kis-switcher] [data-column]').forEach(function (btn) {
      var on = btn.getAttribute('data-column') === String(value);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function restoreCols() {
    var stored = readCols();
    if (!stored) {
      var active = document.querySelector('[data-kis-switcher] [data-column].is-active');
      if (!active) return;
      stored = active.getAttribute('data-column');
      if (isMobile() && (stored === '3' || stored === '4' || stored === '5')) stored = '2';
    }
    applyCols(stored);
  }

  function onSwitcherClick(e) {
    var btn = e.target.closest && e.target.closest('[data-kis-switcher] [data-column]');
    if (!btn) return;
    e.preventDefault();
    var value = btn.getAttribute('data-column');
    writeCols(value);
    applyCols(value);
  }

  /* ---------- filterlade ---------- */
  function onDrawerToggle(e) {
    var details = e.target;
    if (!details.classList || !details.classList.contains('kis-facets__details')) return;
    document.documentElement.classList.toggle('kis-modal-open', details.open);
  }

  function onGroupToggle(e) {
    var details = e.target;
    if (!details.classList || !details.classList.contains('kis-facets__group')) return;
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  /* ---------- init ---------- */
  function init() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-kis-sort]')) onSortChange(e);
    });
    document.addEventListener('click', onSwitcherClick, true);
    document.addEventListener('toggle', onDrawerToggle, true);
    document.addEventListener('toggle', onGroupToggle, true);
    window.addEventListener('popstate', function () { setTimeout(syncSortFromUrl, 50); });

    syncSortFromUrl();
    restoreCols();

    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () { restoreCols(); }).observe(container, { childList: true });
    }
    var mq = window.matchMedia(MOBILE);
    if (mq.addEventListener) mq.addEventListener('change', restoreCols);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
